<template>
  <basic-dialog :show="show" @close="$emit('close')" maxWidth="700">
    <template v-slot:title>{{ editorTitle }}</template>

    <v-row>
      <v-col cols="6">
        <dates-range-picker
          :gtDateFromString="validFrom"
          :gtDateToString="validTo"
          @onRangeSelected="onDateRangeSelected"
          :outlined="outlinedInputs"
          hide-details
        ></dates-range-picker>
      </v-col>
      <v-col>
        <v-text-field
          v-model.number="days"
          :outlined="outlinedInputs"
          label="Days"
          type="number"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="description"
          :outlined="outlinedInputs"
          label="Description"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        ><tags-select v-model="tagsList" :outlined="outlinedInputs"
      /></v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Min Suppliers"
          v-model.number="minSuppliers"
          :outlined="outlinedInputs"
          type="number"
        />
      </v-col>
      <v-col>
        <v-text-field
          label="Max Suppliers"
          v-model.number="maxSuppliers"
          :outlined="outlinedInputs"
          type="number"
        />
      </v-col>
      <v-col>
        <v-text-field
          label="Min Stay"
          v-model.number="minStay"
          :outlined="outlinedInputs"
          type="number"
        />
      </v-col>
      <v-col>
        <v-text-field
          label="Max Stay"
          v-model="maxStay"
          :outlined="outlinedInputs"
          type="number"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Cost %"
          v-model.number="percentCost"
          :outlined="outlinedInputs"
          type="number"
        />
      </v-col>
      <v-col>
        <v-text-field
          label="Sell %"
          v-model.number="percent"
          :outlined="outlinedInputs"
          type="number"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <agent-group-select
          v-model="groupId"
          :outlined="outlinedInputs"
          :groupsOnly="true"
        ></agent-group-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <date-picker
          v-model="bookAfter"
          :outlined="outlinedInputs"
          customLabel="Itinerary Created From"
          hide-details
        />
      </v-col>
      <v-col>
        <date-picker
          v-model="bookBy"
          :outlined="outlinedInputs"
          customLabel="Itinerary Created To"
          hide-details
        />
      </v-col>
    </v-row>
    <changelogs-dialog
      v-if="value && value.id"
      :owner-id="value.id"
      :show="showChangelogs"
      @close="showChangelogs = false"
    />
    <template v-slot:actions>
      <v-btn @click="onShowChangelogs">Logs</v-btn>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <v-row v-if="debug">
      <v-col cols="12">
        value:
        <code>{{ bookBy }}</code>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import AgentGroupSelect from "../../shared/AgentGroupSelect.vue";
import BasicDialog from "../../shared/BasicDialog.vue";
import DatePicker from "../../shared/DatePicker.vue";
import DatesRangePicker from "../../shared/DatesRangePicker.vue";
import TagsSelect from "../../shared/TagsSelect.vue";
import ChangelogsDialog from "../../shared/ChangelogsDialog.vue";
export default {
  name: "edit-circuit-discount-dialog",

  props: {
    value: {
      type: Object,
      default: null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  components: {
    BasicDialog,
    DatesRangePicker,
    DatePicker,
    TagsSelect,
    AgentGroupSelect,
    ChangelogsDialog,
  },

  data() {
    return {
      debug: false,
      description: this.value ? this.value.description : "",
      tagsList: this.value ? this.value.tagsList : "",
      validFrom: this.value ? this.value.validFrom : "",
      validTo: this.value ? this.value.validTo : "",
      bookBy: this.value ? this.value.bookBy : "",
      bookAfter: this.value ? this.value.bookAfter : "",
      days: this.value ? this.value.days : 0,
      minStay: this.value ? this.value.minStay : 0,
      maxStay: this.value ? this.value.maxStay : 0,
      minSuppliers: this.value ? this.value.minSuppliers : 0,
      maxSuppliers: this.value ? this.value.maxSuppliers : 0,
      percent: this.value ? this.value.percent : 0,
      percentCost: this.value ? this.value.percentCost : 0,
      free: this.value ? this.value.free : 0,
      groupId: this.value ? this.value.groupId : 0,
      showChangelogs: false,
    };
  },

  computed: {
    editorTitle() {
      return this.description != ""
        ? this.description
        : "Edit Circuit Discount";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return (
        this.description != "" &&
        this.validFrom != "" &&
        this.validTo != "" &&
        this.tagsList != ""
      );
    },
  },

  watch: {
    value(newVal) {
      this.description = newVal ? newVal.description : "";
      this.tagsList = newVal ? newVal.tagsList : "";
      this.validFrom = newVal ? newVal.validFrom : "";
      this.validTo = newVal ? newVal.validTo : "";
      this.bookBy = newVal ? newVal.bookBy : "";
      this.bookAfter = newVal ? newVal.bookAfter : "";
      this.days = newVal ? newVal.days : 0;
      this.minStay = newVal ? newVal.minStay : 0;
      this.maxStay = newVal ? newVal.maxStay : 0;
      this.minSuppliers = newVal ? newVal.minSuppliers : 0;
      this.maxSuppliers = newVal ? newVal.maxSuppliers : 0;
      this.percent = newVal ? newVal.percent : 0;
      this.percentCost = newVal ? newVal.percentCost : 0;
      this.free = newVal ? newVal.free : 0;
      this.groupId = newVal ? newVal.groupId : 0;
    },
  },

  methods: {
    onShowChangelogs() {
      this.showChangelogs = true;
    },
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        description: this.description,
        tagsList: this.tagsList,
        validFrom: this.validFrom,
        validTo: this.validTo,
        bookBy: this.bookBy,
        bookAfter: this.bookAfter,
        days: Number(this.days),
        minStay: Number(this.minStay),
        maxStay: Number(this.maxStay),
        minSuppliers: Number(this.minSuppliers),
        maxSuppliers: Number(this.maxSuppliers),
        percent: Number(this.percent),
        percentCost: Number(this.percentCost),
        free: Number(this.free),
        groupId: this.groupId,
      });
    },
    onDateRangeSelected(payload) {
      if (payload.dateFrom) {
        this.validFrom = payload.dateFrom;
      }
      if (payload.dateTo) {
        this.validTo = payload.dateTo;
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/plugins/circuit-discounts/EditCircuitDiscountDialog.vue